function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Form, Field, FormSpy } from 'react-final-form';
import { SelectField } from '@unite-us/ui';
import { isRequired } from '@unite-us/client-utils/dist/utils/validations/validations';
var DropdownMultiplesReferrals = function DropdownMultiplesReferrals(_ref) {
  var _ref$referrals = _ref.referrals,
    referrals = _ref$referrals === void 0 ? [] : _ref$referrals,
    setReferralErrors = _ref.setReferralErrors,
    formRefs = _ref.formRefs,
    setSelectedReferralToLink = _ref.setSelectedReferralToLink,
    serviceTypeName = _ref.serviceTypeName;
  var _useState = useState({
      referralSelected: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    referralList = _useState4[0],
    setReferralList = _useState4[1];
  var registerField = function registerField(fieldId, ref) {
    formRefs.current[fieldId] = ref;
  };
  var generateReferralList = function generateReferralList(referrals) {
    return referrals.map(function (referral, index) {
      var _referral$service, _referral$programs;
      var serviceName = (_referral$service = referral.service) === null || _referral$service === void 0 ? void 0 : _referral$service.name;
      var programName = (_referral$programs = referral.programs) === null || _referral$programs === void 0 || (_referral$programs = _referral$programs.find(function (program) {
        return program === null || program === void 0 ? void 0 : program.name;
      })) === null || _referral$programs === void 0 ? void 0 : _referral$programs.name;
      return {
        label: "Referral ".concat(index + 1, ": ").concat(serviceName, " referral to: ").concat(programName),
        value: "".concat(index)
      };
    });
  };
  var onSetForm = useCallback(function (formInstance) {
    formRefs.current = formInstance;
  }, []);
  useEffect(function () {
    var list = generateReferralList(referrals);
    setReferralList(list);
  }, [referrals]);
  var handleSelectChange = function handleSelectChange(field, value) {
    if (value) {
      setFormData(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, field, value));
      });
      setSelectedReferralToLink(Number(value));
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    initialValues: {
      referralSelected: formData.referralSelected
    },
    onSubmit: function onSubmit() {},
    validate: function validate(values) {
      var errors = {};
      if (!values.referralSelected) {
        errors.referralSelected = "You must select a referral";
      }
      ;
      var fieldErrors = {
        referralSelected: !!errors.referralSelected
      };
      setReferralErrors(0, fieldErrors);
      return errors;
    },
    mutators: {
      setFieldTouched: function setFieldTouched(args, state) {
        var _args = _slicedToArray(args, 2),
          name = _args[0],
          touched = _args[1];
        var field = state.fields[name];
        if (field) {
          field.touched = !!touched;
        }
      }
    },
    render: function render(_ref2) {
      var form = _ref2.form,
        values = _ref2.values;
      onSetForm && onSetForm(form);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "relative mx-auto responsive-max-width"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "font-semibold text-[18px] leading-[28px] text-left mt-4"
      }, "Connect original referral"), /*#__PURE__*/React.createElement("p", {
        className: "font-normal text-[14px] leading-[20px] text-left mt-1"
      }, "The original referral you received was a ".concat(serviceTypeName, " referral. Choose one of the referrals you are sending to connect to the original, to ensure that the sender can view the outcome of their referral.")), /*#__PURE__*/React.createElement(FormSpy, {
        subscription: {
          values: true
        },
        onChange: handleSelectChange
      }), /*#__PURE__*/React.createElement(Field, {
        name: "referralSelected",
        required: true,
        key: "referralSelected"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          className: "custom-select-field mb-3 mt-3",
          ref: function ref(_ref3) {
            return registerField('referralSelected', _ref3);
          },
          id: "referralSelected",
          label: "Choose referral",
          options: referralList,
          labelKey: "label",
          valueKey: "value",
          validations: isRequired,
          placeholder: "Pick one",
          required: true,
          searchEnabled: false,
          inline: false,
          onChange: function onChange(value) {
            return handleSelectChange('referralSelected', value);
          },
          value: formData.referralSelected
        }, params));
      })));
    }
  });
};
DropdownMultiplesReferrals.propTypes = {
  referrals: PropTypes.arrayOf(PropTypes.shape({
    service: PropTypes.shape({
      name: PropTypes.string
    })
  })),
  onSubmit: PropTypes.func.isRequired
};
DropdownMultiplesReferrals.defaultProps = {
  referrals: []
};
export default DropdownMultiplesReferrals;
//# sourceMappingURL=DropdownMultiplesReferrals.js.map